import styled, { css } from 'styled-components';

export const AllStoresSectionWrapper = styled.div`
  margin-top: 20px;
  border: 1px solid rgba(241, 241, 241, 1);
  border-radius: 26px;
  position: relative;
  padding-bottom: 30px;
  ${({ $data }) =>
    $data &&
    css`
      &::before {
        @media (min-width: 768px) {
          content: '';
          position: absolute;
          border: 1px solid var(--success);
          top: 140px;
          left: 20px;
          bottom: ${({ $hasPagination }) => ($hasPagination ? '100px' : '50px')};
        }
      }
    `}
  .business {
    background: rgba(53, 91, 133, 0.05);
    border-radius: 26px 26px 0 0;
    flex-direction: column;
    align-items: flex-start !important;
    width: 100%;
    @media (min-width: 576px) {
      flex-direction: row;
    }
  }
  .stores {
    margin-left: 0px;
    flex-wrap: wrap;
    row-gap: 30px !important;
    @media (min-width: 768px) {
      margin-left: 30px;
      flex-wrap: nowrap;
      row-gap: 0;
    }
  }
  .content-wrap {
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    padding: 16px 40px 16px 20px;

    @media (min-width: 768px) {
      padding: 26px 50px 26px 30px;
    }
    @media (min-width: 576px) {
      padding: 26px 50px 26px 20px;
      gap: 0;
    }
    .dots {
      position: absolute;
      font-size: 22px;
      cursor: pointer;
      right: 10px;
      top: 34px;
      @media (min-width: 576px) {
        right: 20px;
        top: 44px;
      }
      /* .action-btn {
        position: relative;
      } */
    }
  }
  .add-btn {
    width: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    button {
      max-width: 100%;
    }
    @media (min-width: 500px) {
      max-width: 117px;
    }
  }
  .btns-wrap {
    display: flex;
    align-items: center;
    gap: 32px;
  }
`;

export const StoreWrap = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: 16px;
  .arrow {
    cursor: pointer;
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    border-radius: 60px;
    background: linear-gradient(116.03deg, #355b85 5.04%, #1b2e44 86.56%);
    img {
      width: 18px;
      height: 18px;
    }

    @media (min-width: 576px) {
      width: 60px;
      height: 60px;
      img {
        width: 24px;
        height: 25px;
      }
    }
  }
  .title {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    @media (min-width: 576px) {
      font-size: 18px;
      line-height: 22px;
    }
  }
  .desc {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--light-gray);
    @media (min-width: 576px) {
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

export const StoresWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  /* width: 100%; */

  ${({ $adjust }) =>
    $adjust === true &&
    css`
      max-width: 270px;
      width: 100%;
      @media (min-width: 992px) {
        max-width: 400px;
      }
    `}
  @media (max-width: 767px) {
    width: 100%;
  }
  .title {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    @media (min-width: 576px) {
      font-size: 18px;
      line-height: 22px;
    }
  }
  .desc {
    max-width: 270px;
    width: 100%;
    text-overflow: ellipsis;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--light-gray);
    @media (min-width: 768px) {
      font-size: 14px;
      line-height: 18px;
    }
    @media (min-width: 992px) {
      max-width: 400px;
    }
  }
`;
export const PeoplesWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  .profile-wrap {
    display: flex;
    .profile-pic {
      width: 32px;
      height: 32px;
      overflow: hidden;
      border-radius: 50%;
      flex-shrink: 0;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 3px 3px;
      img {
        width: 100%;
        height: auto;
      }
      &:nth-child(1) {
        z-index: 3;
      }
      &:nth-child(2) {
        z-index: 2;
        margin-left: -8px;
      }
      &:nth-child(3) {
        z-index: 1;
        margin-left: -8px;
      }
    }
  }
  .success {
    font-size: 12px;
    font-weight: 300;
    line-height: 16px;
    color: var(--success);
    text-decoration: underline;
    cursor: pointer;
  }
`;
